(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9603],{

/***/ 61691:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var _Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _modules_study_search__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97040);
/* harmony import */ var _unisearch_theme_layout__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(81496);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85893);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }






var Search = function Search(_ref) {
  var searchParams = _ref.searchParams,
      location = _ref.location,
      courseLevel = _ref.courseLevel,
      specialization = _ref.specialization,
      examType = _ref.examType,
      fees = _ref.fees,
      courseDuration = _ref.courseDuration,
      filterResult = _ref.filterResult,
      loading = _ref.loading;

  var params = _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, searchParams), searchParams.crlvl && {
    crlvl: searchParams.crlvl.split(",")
  }), searchParams.st && {
    st: searchParams.st.split(",")
  }), searchParams.sp && {
    sp: searchParams.sp.split(",")
  }), searchParams.ex && {
    ex: searchParams.ex.split(",")
  }), searchParams.co && {
    co: searchParams.co.split(",")
  }), searchParams.ci && {
    ci: searchParams.ci.split(",")
  });

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_unisearch_theme_layout__WEBPACK_IMPORTED_MODULE_2__/* .LayoutMain */ .Ku, {
    title: "Search University",
    metaUrl: "".concat("https://myunisearch.com", "/search"),
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_modules_study_search__WEBPACK_IMPORTED_MODULE_1__/* .SearchFilter */ .a, {
      searchParams: params,
      location: location,
      courseLevel: courseLevel,
      specialization: specialization,
      examType: examType,
      fees: fees,
      courseDuration: courseDuration,
      filterResult: filterResult,
      loadings: loading
    })
  });
};

var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (Search); //serverside props

/***/ }),

/***/ 3417:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/search",
      function () {
        return __webpack_require__(61691);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1228,5445,5937,2013,4617,955,9866,3874,6556,7662,260,1086,2884,8719,8322,5824,3480,5551,5260,926,3063,6665,1707,5996,1010,1496,5603,4274,9774,2888,179], function() { return __webpack_exec__(3417); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);